import _objectSpread from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DEFAULT_SERVICES } from '@/views/review/constant.js';
import { getServices as _getServices } from '@/api/home.js';
import callService from '@/utils/call-service';
export default {
  props: {
    subjectCode: {
      type: Number,
      default: 1
    },
    errorTextUrl: {
      type: String,
      default: ''
    },
    reviewNoteUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      edu: JSON.parse(localStorage.getItem('userInfo')).edu,
      // 学段
      serviceList: DEFAULT_SERVICES
    };
  },
  watch: {
    subjectCode: {
      immediate: true,
      handler: function handler(val) {
        if (!this.subjectCode) return;
        this.getServices(); // 切换学科
      }
    }
  },
  created: function created() {
    this.getServices();
  },
  methods: {
    getServices: function getServices() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_getServices, status, data, exclusiveList, SERVICE_TYPES, SERVICE_ICON_MAP;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _getServices({
                  edu: _this.edu,
                  subjectId: _this.subjectCode,
                  entry: 4
                });

              case 2:
                _yield$_getServices = _context.sent;
                status = _yield$_getServices.status;
                data = _yield$_getServices.data;

                if (!(status !== 1)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                exclusiveList = data.exclusiveList;

                if (exclusiveList.length) {
                  SERVICE_TYPES = [17]; // [16, 17]

                  SERVICE_ICON_MAP = {
                    16: 'review_error_img.png',
                    17: 'review_note_img.png'
                  };
                  _this.serviceList = exclusiveList.filter(function (item) {
                    return SERVICE_TYPES.includes(item.type);
                  }).map(function (item) {
                    return _objectSpread({
                      icon: SERVICE_ICON_MAP[item.type]
                    }, item);
                  });
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(url) {
      callService(url, this);
    }
  }
};